<template>
  <div>
    <page-title-bar :customTitle="customTitle"></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-toolbar :elevation="0" height="auto">
            <v-layout row justify-start align-center style="padding: 32px">
              <v-flex xs12 md3>
                <v-select
                  :items="yearOptions"
                  v-model="chosen_year"
                  label="Chọn năm"
                  outlined
                  dense
                ></v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-right">
                <v-btn color="success" class="mr-2" @click="exportExcel" :loading="exporting" :disabled="loader || !monthsData || monthsData.length === 0">
                  <v-icon left small>cloud_download</v-icon>
                  Xuất Excel
                </v-btn>
              </v-flex>
            </v-layout>
          </v-toolbar>

          <div class="mt-3">
            <v-card>
              <v-card-title class="headline">
                Báo cáo lợi nhuận chưa phân phối năm {{ chosen_year }}
              </v-card-title>
              <v-divider></v-divider>

              <!-- Loading State -->
              <v-card-text v-if="loader" class="text-center pa-5">
                <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                <p class="mt-3">Đang tải báo cáo...</p>
              </v-card-text>

              <!-- Report Content -->
              <v-card-text v-else-if="monthsData && monthsData.length > 0">
                <div class="table-responsive">
                  <table class="report-table">
                    <thead>
                      <tr>
                        <th class="text-left" style="min-width: 300px; position: sticky; left: 0; z-index: 10; background: #f5f5f5;">Chỉ tiêu</th>
                        <th v-for="item in monthsData" :key="item.report_month" class="text-right" style="min-width: 150px">
                           {{ formatMonthHeader(item.report_month) }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- OPENING -->
                      <tr>
                        <td style="position: sticky; left: 0; z-index: 10;">
                            <strong>Số dư đầu kỳ</strong>
                        </td>
                        <td v-for="item in monthsData" :key="item.month" class="text-right">
                           <strong>{{ formatCurrency(item.report_data.opening_balance) }}</strong>
                        </td>
                      </tr>

                      <!-- PROFIT -->
                      <tr  class="highlight-row">
                        <td style="position: sticky; left: 0; z-index: 10;">
                            1. Lợi nhuận trong kỳ
                        </td>
                         <td v-for="item in monthsData" :key="item.month" class="text-right">
                           {{ formatCurrency(item.report_data.profit_for_period) }}
                        </td>
                      </tr>

                      <!-- LOAN -->
                      <tr class="highlight-row" style="cursor: pointer" @click="toggleExpand('loan')">
                        <td style="position: sticky; left: 0; background: #e3f2fd; z-index: 10;">
                            2. Trả nợ vay
                            <v-icon small class="ml-1">
                               {{ expanded.loan ? 'expand_less' : 'expand_more' }}
                            </v-icon>
                        </td>
                         <td v-for="item in monthsData" :key="item.month" class="text-right">
                           <strong>{{ formatCurrency(item.report_data.loan_repayment_net) }}</strong>
                        </td>
                      </tr>
                      
                      <!-- Loan Details -->
                      <template v-if="expanded.loan">
                         <tr v-for="key in allLoanKeys" :key="'loan_' + key" class="detail-row">
                           <td class="pl-4" style="position: sticky; left: 0; background: #fafafa; z-index: 10;">
                               - {{ key }}
                           </td>
                            <td v-for="item in monthsData" :key="item.month" class="text-right">
                               {{ formatCurrency(getDetailValue(item, 'loan_details', key)) }}
                            </td>
                         </tr>
                      </template>

                      <!-- PERSONAL SPENDING -->
                      <tr class="highlight-row" style="cursor: pointer" @click="toggleExpand('personal')">
                        <td style="position: sticky; left: 0; background: #e3f2fd; z-index: 10;">
                            3. Chi cá nhân (Thu/Chi LNCCP)
                            <v-icon small class="ml-1">
                               {{ expanded.personal ? 'expand_less' : 'expand_more' }}
                            </v-icon>
                        </td>
                         <td v-for="item in monthsData" :key="item.month" class="text-right">
                           <strong>{{ formatCurrency(item.report_data.personal_spending_net) }}</strong>
                        </td>
                      </tr>

                      <!-- Personal Details -->
                      <template v-if="expanded.personal">
                         <tr v-for="key in allPersonalKeys" :key="'personal_' + key" class="detail-row">
                           <td class="pl-4" style="position: sticky; left: 0; background: #fafafa; z-index: 10;">
                               - {{ key }}
                           </td>
                            <td v-for="item in monthsData" :key="item.month" class="text-right">
                               {{ formatCurrency(getDetailValue(item, 'personal_spending_details', key)) }}
                            </td>
                         </tr>
                      </template>


                      <!-- CLOSING -->
                      <tr class="total-row">
                        <td style="position: sticky; left: 0; background: #fff3e0; z-index: 10;">
                            <strong>Số dư cuối kỳ</strong>
                        </td>
                        <td v-for="item in monthsData" :key="item.month" class="text-right">
                           <strong>{{ formatCurrency(item.report_data.closing_balance) }}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card-text>

              <v-card-text v-else class="text-center pa-5">
                <v-icon size="60" color="grey lighten-1">info</v-icon>
                <p class="mt-3 grey--text">Chưa có báo cáo tháng nào được chốt trong năm {{ chosen_year }}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import api from "../../api";
import moment from "moment";
import swal from "sweetalert2";
import { ExcelExporter } from '../../helpers/ExcelExporter';

export default {
  data() {
    return {
      loader: false,
      exporting: false,
      chosen_year: new Date().getFullYear().toString(),
      monthsData: [],
      expanded: {
        loan: true,
        personal: true
      }
    };
  },
  computed: {
    yearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let y = 2025; y <= currentYear; y++) {
        years.push(y.toString());
      }
      return years;
    },
    // Collect all unique keys (text) for details
    allLoanKeys() {
        if (!this.monthsData) return [];
        const keys = new Set();
        this.monthsData.forEach(item => {
            if (item.report_data && item.report_data.loan_details) {
                item.report_data.loan_details.forEach(d => keys.add(d.text));
            }
        });
        return Array.from(keys).sort();
    },
    allPersonalKeys() {
        if (!this.monthsData) return [];
         const keys = new Set();
        this.monthsData.forEach(item => {
            if (item.report_data && item.report_data.personal_spending_details) {
                item.report_data.personal_spending_details.forEach(d => keys.add(d.text));
            }
        });
        return Array.from(keys).sort();
    }
  },
  watch: {
    chosen_year: function() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatMonthHeader(monthStr) {
        return moment(monthStr).format("MM/YYYY");
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "-";
      const num = Number(value);
      if (num === 0) return "0";
      const formatted = Math.abs(num).toLocaleString("vi-VN");
      return num < 0 ? `(${formatted})` : formatted;
    },
    toggleExpand(key) {
        this.expanded[key] = !this.expanded[key];
    },
    getDetailValue(item, listField, keyText) {
        if (item.report_data && item.report_data[listField]) {
            const detailItem = item.report_data[listField].find(i => i.text === keyText);
            return detailItem ? detailItem.amount : 0;
        }
        return 0;
    },
    async getData() {
      this.loader = true;
      this.monthsData = [];
      try {
        const result = await api.getYearlyUndistributedProfitReport(`year=${this.chosen_year}`);
        if (result.status === 200 || result.status === 304) {
           this.monthsData = result.data.months || []; 
        }
      } catch (error) {
        console.error(error);
      }
      this.loader = false;
    },
    async exportExcel() {
        if (!this.monthsData || this.monthsData.length === 0) return;
        this.exporting = true;
        try {
            // Define Columns
            const columns = [
                { header: 'Chỉ tiêu', key: 'name', width: 40, style: { bold: true } }
            ];
            this.monthsData.forEach(m => {
                columns.push({
                    header: this.formatMonthHeader(m.report_month),
                    key: m.report_month,
                    width: 20,
                    align: 'right',
                    format: 'currency'
                });
            });

            const data = [];

            // Helper to create row object
            const createRow = (name, fieldPath, style = {}) => {
                const row = { name, style };
                this.monthsData.forEach(m => {
                    // Navigate to field
                    let val = m.report_data;
                    if (fieldPath) {
                        const parts = fieldPath.split('.');
                        for (const part of parts) {
                            val = val ? val[part] : 0;
                        }
                    }
                    row[m.report_month] = val;
                });
                return row;
            };

            const createDetailRow = (name, listField, keyText, style = {}) => {
                const row = { name, style };
                if (style.indent) row.outlineLevel = style.indent;
                this.monthsData.forEach(m => {
                    const val = this.getDetailValue(m, listField, keyText);
                     row[m.report_month] = val;
                });
                return row;
            }

            // 1. Opening
            data.push(createRow('Số dư đầu kỳ', 'opening_balance', { bold: true }));

            // 2. Profit
            data.push(createRow('1. Lợi nhuận trong kỳ', 'profit_for_period', { background: 'FFE3F2FD' }));

            // 3. Loan
            data.push(createRow('2. Trả nợ vay', 'loan_repayment_net', { bold: true, background: 'FFE3F2FD' }));
            this.allLoanKeys.forEach(key => {
                data.push(createDetailRow(key, 'loan_details', key, { indent: 1 }));
            });

            // 4. Personal
            data.push(createRow('3. Chi cá nhân (Thu/Chi LNCCP)', 'personal_spending_net', { bold: true, background: 'FFE3F2FD' }));
            this.allPersonalKeys.forEach(key => {
                data.push(createDetailRow(key, 'personal_spending_details', key, { indent: 1 }));
            });

            // 5. Closing
            data.push(createRow('Số dư cuối kỳ', 'closing_balance', { bold: true, background: 'FFFFF3E0' }));


            await ExcelExporter.exportReport({
                title: 'BÁO CÁO LỢI NHUẬN CHƯA PHÂN PHỐI',
                subtitle: `Năm ${this.chosen_year}`,
                columns: columns,
                data: data,
                fileName: `BaoCaoLNCPP_${this.chosen_year}`
            });

        } catch (error) {
            console.error(error);
            swal.fire("Lỗi", "Không thể xuất file Excel", "error");
        }
        this.exporting = false;
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  max-width: 100%;
}

.report-table {
  border-collapse: collapse;
  min-width: 100%;
}

.report-table th,
.report-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #f0f0f0;
  white-space: nowrap;
}

.report-table th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.report-table .highlight-row td {
  background-color: #e3f2fd;
  font-weight: normal;
}

.report-table .total-row td {
  background-color: #fff3e0;
  font-weight: bold;
}

.report-table .detail-row td {
  background-color: #fafafa;
  color: #666;
}

.pl-4 {
  padding-left: 32px !important;
}
</style>
